'use client';

import { useState } from 'react';
import Link from 'next/link';

import LoginModal from '@/components/auth/loginModal';
import { useAuth } from '@/providers/userContext';
import { setPostLoginRedirect } from '@/lib/client/postLoginRedirect';

export default function FooterProtectedLink({ href, children, external = false, className = '' }) {
  const { user } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const baseClassName =
    'block text-base lg:text-white/75 text-white leading-[1.25em] py-1 cursor-pointer transition hover:text-white';
  const combinedClassName = className ? `${baseClassName} ${className}` : baseClassName;

  if (user) {
    if (external) {
      return (
        <a href={href} className={combinedClassName} target="_blank" rel="noreferrer">
          {children}
        </a>
      );
    }
    return (
      <Link href={href} className={combinedClassName}>
        {children}
      </Link>
    );
  }

  return (
    <>
      <button
        type="button"
        className={combinedClassName}
        onClick={() => {
          setPostLoginRedirect(href);
          setShowLoginModal(true);
        }}
      >
        {children}
      </button>
      {showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />}
    </>
  );
}
